const campaignPopupConfig = {
	storefrontAccessToken: 'a35224058d47b6514caa11ee62e9de62', // Default storefront token from Zer4U integrations app
	utmSource: document.currentScript?.getAttribute('data-utm-source'),
};

document.addEventListener('DOMContentLoaded', initCampaignPopup);

// eslint-disable-next-line max-lines-per-function, complexity
async function initCampaignPopup() {
	if (!campaignPopupConfig.storefrontAccessToken || !campaignPopupConfig.utmSource) {
		return;
	}

	const urlParams = new URLSearchParams(window.location.search);
	const utmSource = urlParams.get('utm_source');
	const utmCampaign = urlParams.get('utm_campaign');

	if (utmSource !== campaignPopupConfig.utmSource) {
		return;
	}

	const popup = document.getElementById('campaign-popup');
	if (!popup) {
		return;
	}

	const sessionKey = 'campaignPopupShown';

	if (sessionStorage.getItem(sessionKey) === 'true') {
		return;
	}

	let codeCoupon = null;
	try {
		const response = await fetch('/api/2025-10/graphql.json', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': campaignPopupConfig.storefrontAccessToken,
			},
			body: JSON.stringify({
				query: `
          query CampaignMetaobject($handle: String!, $type: String!) {
            metaobject (handle: { handle: $handle, type: $type }) {
              codeCoupon: field(key: "code_coupoun") {
                value
              }
            }
          }
        `,
				variables: {
					handle: utmCampaign,
					type: 'campaign_code_coupuns',
				},
			}),
		});

		if (!response.ok) {
			return;
		}

		const result = await response.json();

		const metaobject = result?.data?.metaobject;

		if (!metaobject || !metaobject.codeCoupon) {
			return;
		}
		codeCoupon = metaobject.codeCoupon?.value || null;
	} catch (e) {
		return;
	}

	if (!codeCoupon) {
		return;
	}

	const root = window.themeVariables?.routes?.rootUrlWithoutSlash || '';
	const discountUrl = `${window.location.origin}${root}/discount/${encodeURIComponent(codeCoupon)}`;
	const ctaLink = popup.querySelector('[data-campaign-popup-link]');

	if (ctaLink) {
		ctaLink.setAttribute('href', discountUrl);
	}

	popup.open = true;
	sessionStorage.setItem(sessionKey, 'true');

	const closeButton = popup.querySelector('[data-action="close"]');

	if (closeButton) {
		closeButton.addEventListener('click', () => {
			popup.open = false;
		});
	}
}
